import { FormActionButton } from '@workwave-tidal/core/form'

import { useResetEditingState } from '@/atoms'

import { form } from '../../../formState'
import { useTexts } from '../../../hooks/useTexts'

export function Footer() {
  const { field: idField } = form.useFormField('id')
  const resetEditing = useResetEditingState()

  const texts = useTexts()

  const {
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  // When creating a new entity the submit button should be enabled also when the form is in a pristine status
  const saveDisabled =
    idField.value === ''
      ? validating || submitting
      : status === 'pristine' || validating || submitting

  return (
    <>
      <FormActionButton
        label={texts.cancel}
        size="medium"
        onClick={resetEditing}
        testId="footer-secondary-button"
        data-trackid="footer-secondary-button"
      />
      <FormActionButton
        label={texts.save}
        disabled={saveDisabled}
        size="medium"
        variant="contained"
        type="submit"
        loading={submitting || validating}
        testId="footer-primary-button"
        data-trackid="footer-primary-button"
      />
    </>
  )
}
